// @flow

export const NOTIFICACTIONS_MANAGER_STATE = 'notificationsManagerWebPush';



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/constants.js